import { Controller } from "stimulus"
import './component.scss'

class CompanyFaqController extends Controller {
  static targets = ["item", "answer", "icon"]

  toggle(event) {
    const item = event.currentTarget.closest('.company-faq__item')
    if (!item) return

    const isOpen = item.classList.contains('is-open')

    if (isOpen) {
      item.classList.remove('is-open')
    } else {
      item.classList.add('is-open')
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('company-faq', CompanyFaqController)
